import React from "react";
import Header from "./Hero Section/Header";
import Side from "./Hero Section/Side";
import "../styles/Demande.css";
import { useTranslation } from "react-i18next";
import Car from "../assets/images/Demande/car.png";
import Camion from "../assets/images/Demande/cargo-truck.png";
import Truck from "../assets/images/Demande/truck.png";
import Moto from "../assets/images/Demande/moto.png";
import Bus from "../assets/images/Demande/bus-side-view.png";
import Engine from "../assets/images/Demande/tractor.png";


export default function Demande() {
  const { t } = useTranslation();

  const selectInfo = [
    { title: t('Demande.transport')},
    { title: t('Demande.flotte') },
    { title: t('Demande.passagers') },
    { title: t('Demande.construcion') },
    { title: t('Demande.location') },
  ];

  return (
    <>
      <Side />
      <Header />
      <section className="Demande-container">
        <h1>
          <span className="SpanHighlightWhite">{t("Demande.title")}</span>
        </h1>
      </section>
      <div className="background-demande">
        
        <form className="demande-form" name="demande-form" id="demande-form" action="https://formsubmit.co/77a8b6c97510f429fae14ee631564a5f" method="POST">
          <h1>{t('Demande.vehicle-title')}</h1>
        <div className="demande-vehicle">
          <div className="vehicles">
            <div>
              <img src={Car} alt="car"/>
              <label>
              <span>{t("Demande.car")}</span>
              <input className="input" type="number" name="car" required />
            </label>
            </div>
            <div>
              <img src={Moto} alt="car"/>
              <label>
              <span>{t("Demande.moto")}</span>
              <input className="input" type="number" name="camion" required />
            </label>
            </div>
          </div>
          {/*  */}
          <div className="vehicles">
          <div>
              <img src={Camion} alt="camion"/>
              <label>
              <span>{t("Demande.camion")}</span>
              <input className="input" type="number" name="Poids-Lourds" required />
            </label>
            </div>
            <div>
              <img src={Bus} alt="bus"/>
              <label>
              <span>{t("Demande.bus")}</span>
              <input className="input" type="number" name="moto" required />
            </label>
            </div>
          </div>
          {/*  */}
          <div className="vehicles">
          <div>
              <img src={Truck} alt="truck"/>
              <label>
              <span>{t("Demande.truck")}</span>
              <input className="input" type="number" name="bus" required />
            </label>
            </div>
            <div>
              <img src={Engine} alt="BTP"/>
              <label>
              <span>{t("Demande.btp")}</span>
              <input className="input" type="number" name="BTP" required />
            </label>
            </div>
          </div>
        </div>
          <h1>{t('Demande.form-title')}</h1>
          <div className="flex">
            <label>
              <span>{t("contactInfo.nom")}</span>
              <input className="input" type="text" name="name" required />
            </label>
            <label>
              <span>Organisation</span>
              <input className="input" type="text" name="organisation" required />
            </label>
          </div>

          <div className="flex">
            <label>
              <span>{t("Demande.activite")}</span>
              <select name="Secteur d'activite">
                <option disabled={true} selected={true}>
                  {t("Demande.secteur")}
                </option>
                {selectInfo.map((info, index) => {
                  return (
                    <option key={index} value={info.title}>
                      {info.title}
                    </option>
                  );
                })}
              </select>
            </label>
            <label>
              <span>E-mail</span>
              <input className="input" type="email" name="email" required />
            </label>
          </div>

          <div className="flex">
            <label>
              <span>{t("contactInfo.telephone")}</span>
              <input className="input" type="number" name="telephone" required />
            </label>
            <label>
              <span>{t("Demande.adresse")}</span>
              <input className="input" type="text" name="adresse" required />
            </label>
          </div>

          {/* checkbox section */}

          <section className="demande-checkbox">
            {/* 1 */}
            <div className="checkbox-items">
              <div>
                <input
                  type="checkbox"
                  name="Ameliorer votre qualité de service"
                  value="Ameliorer votre qualité de service"
                />
                <span>{t('Demande.Ameliorer')}</span>
              </div>
              <div>
                <input
                  type="checkbox"
                  name="Securiter de votre conducteur et celle de vos vehicules"
                  value="Securiter de votre conducteur et celle de vos vehicules"
                />
                <span>
                {t('Demande.Securiter')}
                </span>
              </div>
            </div>

            {/* 2 */}
            <div className="checkbox-items">
              <div>
                <input
                  type="checkbox"
                  name="Optimiser vos temps de travail et d'attente"
                  value={"Optimiser vos temps de travail et d'attente"}
                />
                <span>{t('Demande.Optimiser')}</span>
              </div>
              <div>
                <input
                  type="checkbox"
                  name="minimiser les charges"
                  value={"minimiser les charges"}
                />
                <span>{t('Demande.minimiser')}</span>
              </div>
            </div>

            {/* 3 */}
            <div className="checkbox-items">
              <div>
                <input
                  type="checkbox"
                  name="ameliorer la productivité de votre equipe"
                  value={"ameliorer la productivité de votre equipe"}
                />
                <span>{t('Demande.productivite')}</span>
              </div>
              <div>
                <input
                  type="checkbox"
                  name="optimiser la consommation du carburant"
                  value={"optimiser la consommation du carburant"}
                />
                <span>{t('Demande.consommation')}</span>
              </div>
            </div>
          </section>
          <div className="flex">
            <button>
              <div className="svg-wrapper-1">
                <div className="svg-wrapper">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    width={24}
                    height={24}
                  >
                    <path fill="none" d="M0 0h24v24H0z" />
                    <path
                      fill="currentColor"
                      d="M1.946 9.315c-.522-.174-.527-.455.01-.634l19.087-6.362c.529-.176.832.12.684.638l-5.454 19.086c-.15.529-.455.547-.679.045L12 14l6-8-8 6-8.054-2.685z"
                    />
                  </svg>
                </div>
              </div>
              <span>Send</span>
            </button>
          </div>
        </form>
      </div>
    </>
  );
}
